import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useState, createElement, cloneElement, useEffect } from 'react';
import PropTypes from 'prop-types';
import Window from './components/Window';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var WindowsContainer = function WindowsContainer(_ref) {
  var onWindowClick = _ref.onWindowClick,
      onWindowClose = _ref.onWindowClose,
      onWindowDragStart = _ref.onWindowDragStart,
      onWindowDragStop = _ref.onWindowDragStop,
      onWindowResize = _ref.onWindowResize,
      set = _ref.set,
      windows = _ref.windows,
      children = _ref.children;

  var _useState = useState({
    width: null,
    height: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var ref = useRef();

  var resize = function resize() {
    // TODO handle sizes in rem
    var pxWidth = null;
    var pxHeight = null; // get available width and height

    if (ref.current && typeof ref.current.clientWidth !== 'undefined' && typeof ref.current.clientHeight !== 'undefined') {
      pxHeight = ref.current.clientHeight;
      pxWidth = ref.current.clientWidth;
    }

    if (pxWidth || pxHeight) {
      if (pxWidth !== size.width || pxHeight !== size.height) {
        setSize({
          width: pxWidth,
          height: pxHeight
        });
      }
    }
  };

  useEffect(function () {
    resize();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', resize, {
        passive: true
      }); //todo IE
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', resize);
      }
    };
  }, []);

  var onWindowClickSelf = function onWindowClickSelf(windowKey) {
    onWindowClick(windowKey);
  };

  var onWindowCloseClick = function onWindowCloseClick(windowKey) {
    onWindowClose(windowKey);
  };

  var onWindowDragStartSelf = function onWindowDragStartSelf(windowKey) {
    onWindowDragStart(windowKey);
  };

  var onWindowDragStopSelf = function onWindowDragStopSelf(windowKey, position) {
    onWindowDragStop(windowKey, position);
  };

  var onWindowResizeSelf = function onWindowResizeSelf(windowKey, width, height, position) {
    onWindowResize(windowKey, width, height, position);
  };

  var renderWindow = function renderWindow(key, index, settings, content) {
    return /*#__PURE__*/_jsx(Window, _objectSpread({
      containerHeight: size.height,
      containerWidth: size.width,
      content: content,
      onClick: onWindowClickSelf,
      onCloseClick: onWindowCloseClick,
      onDragStart: onWindowDragStartSelf,
      onDragStop: onWindowDragStopSelf,
      onResize: onWindowResizeSelf,
      windowKey: key,
      withoutTilte: !settings.title,
      zIndex: index
    }, settings), key);
  };

  var renderWindows = function renderWindows() {
    if (set) {
      var order = set.orderByHistory;
      return order.map(function (windowKey, index) {
        var window = windows[windowKey];

        if (window.data.component && typeof window.data.component === 'function') {
          return renderWindow(window.key, index, window.data.settings, /*#__PURE__*/createElement(window.data.component, _objectSpread({}, window.data.props)));
        } else {
          return renderWindow(window.key, index, window.data.settings, /*#__PURE__*/cloneElement(window.data.component));
        }
      });
    } else {
      return null;
    }
  }; // TODO what if any child is Window component?


  return /*#__PURE__*/_jsxs("div", {
    className: "ptr-windows-container",
    ref: ref,
    children: [children, renderWindows()]
  });
};

WindowsContainer.propTypes = {
  onWindowClick: PropTypes.func,
  onWindowClose: PropTypes.func,
  onWindowDragStart: PropTypes.func,
  onWindowDragStop: PropTypes.func,
  onWindowResize: PropTypes.func,
  set: PropTypes.shape({
    orderByHistory: PropTypes.array
  }),
  windows: PropTypes.object,
  children: PropTypes.node
};
export default WindowsContainer;